module.exports = __webpack_public_path__ + "img/google-play.ae598caa.png";